import SEOMeta from '@/components/base/SEOMeta';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturedSection from './components/FeaturedSection';
import CategorySection from './components/CategorySection';
import LatestSection from './components/LatestSection';
import TestimonialSection from './components/TestimonialSection';
import CTASection from './components/CTASection';

const organizationLd = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '韩漫网',
  url: 'http://ynbskj.cn/',
  description: '韩漫网 - 免费韩国漫画在线阅读平台，提供海量韩漫资源，无需注册即可阅读',
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '+86-10-8888-6666',
    contactType: 'customer service',
    areaServed: 'CN',
    availableLanguage: 'zh-CN',
  },
};

const websiteLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '韩漫网',
  url: 'http://ynbskj.cn/',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'http://ynbskj.cn/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const faqLd = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: '韩漫网是否需要注册才能阅读？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '不需要。韩漫网所有漫画均免费阅读，无需注册账号，打开网站即可开始阅读。',
      },
    },
    {
      '@type': 'Question',
      name: '韩漫网支持哪些设备阅读？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '韩漫网支持手机、平板、电脑等多种设备，自适应不同屏幕尺寸，随时随地畅享阅读。',
      },
    },
    {
      '@type': 'Question',
      name: '韩漫网的漫画资源更新频率如何？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '韩漫网每日更新大量韩国漫画资源，热门漫画保持与官方同步更新，确保读者第一时间看到最新章节。',
      },
    },
    {
      '@type': 'Question',
      name: '韩漫网有哪些漫画分类？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '韩漫网提供热血、爱情、悬疑、奇幻、校园、耽美、恐怖、搞笑、科幻等多种分类，满足不同读者的阅读偏好。',
      },
    },
  ],
};

export default function HomePage() {
  return (
    <>
      <SEOMeta
        title="韩漫网站-韩漫免费漫画-漫画韩漫网址-在线阅读韩国漫画"
        description="通过韩漫网站，您可以免费在线阅读大量韩国漫画，无需注册即可访问，支持多种设备，带来便捷的阅读乐趣和丰富题材选择。每日更新，海量韩漫资源尽在韩漫网。"
        keywords="韩漫网站,免费漫画,在线阅读,韩国漫画,漫画资源,韩漫免费漫画,漫画韩漫网址"
        canonicalUrl="http://ynbskj.cn/"
        ogImage="https://readdy.ai/api/search-image?query=Korean%20manhwa%20website%20open%20graph%20image%2C%20dark%20atmospheric%20manga%20style%20collage%2C%20multiple%20comic%20covers%20arranged%20artistically%2C%20warm%20accent%20colors%2C%20Korean%20webtoon%20aesthetic%2C%20professional%20digital%20art&width=1200&height=630&seq=home-og-image&orientation=landscape"
        jsonLd={[organizationLd, websiteLd, faqLd]}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          <article>
            <HeroSection />
            <FeaturedSection />
            <CategorySection />
            <LatestSection />
            <TestimonialSection />
            <CTASection />
          </article>
        </main>

        <Footer />
      </div>
    </>
  );
}